import React, {lazy, Suspense} from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {BrowserRouter} from 'react-router-dom'
import reportWebVitals from './reportWebVitals';
import common_en from './translations/English/common.json';
import common_ru from './translations/Russian/common.json';
import common_ka from './translations/Georgian/common.json';
import {
    ChakraProvider,
    extendTheme,
} from "@chakra-ui/react";
import i18next from "i18next";
import {I18nextProvider} from "react-i18next";


const customTheme = extendTheme({
    colors: {
        brand: {
            50: "#52537B",
            100: "#52537B",
            500: "#52537B", // you need this
        }
    },
});

i18next.init({
    interpolation: {escapeValue: false},
    lng: "English",
    resources: {
        Russian: {
            common: common_ru               // 'common' is our custom namespace
        },
        English: {
            common: common_en
        },
        Georgian: {
            common: common_ka
        },
    },
});


ReactDOM.render(
    <React.Fragment>
        <I18nextProvider i18n={i18next}>
            <ChakraProvider theme={customTheme}>
                <BrowserRouter>
                    <Suspense fallback={<h1>Loading Data...</h1>}>
                        <App/>
                    </Suspense>
                </BrowserRouter>
            </ChakraProvider>
        </I18nextProvider>
    </React.Fragment>
    ,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
